import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';
import {
  Link,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { PdsIcon } from '@/modules/perseo-billing/ui/react/src/components/gamma';

export const HelpFeedback = () => {
  const { contactFormButtonGtm, requestCancelationGtm } =
    useGtmBillingProduct();

  return (
    <div
      tabIndex={0}
      className="co-flex co-rounded-8px co-border-1 co-p-8px co-border-pds-information-500 co-bg-pds-information-100 co-gap-x-2"
    >
      <div className="co-flex co-self-start co-p-1 co-flex-shrink-0">
        <PdsIcon
          icon="PdsFilledInfoCircle"
          className="co-fill-pds-information-500"
        />
      </div>

      <div className="co-flex co-flex-col">
        <Typography weight="semibold">¿Necesitas ayuda?</Typography>

        <div className="co-inline-block co-text-[14px] co-text-pds-neutral-900">
          <span className="co-inline-block co-whitespace-pre">
            {'Completa nuestro '}
          </span>
          <span className="co-inline-block">
            <Link
              target="_blank"
              underline="always"
              onClick={contactFormButtonGtm}
              weight="medium"
              href="https://ayuda.paris.cl/ayuda/contactanos"
              children={'formulario de contacto'}
            />
          </span>
          <span className="co-inline-block co-whitespace-pre"> </span>
          <span className="co-inline-block co-whitespace-pre">
            {'para recibir asistencia. También puedes '}
          </span>
          <span className="co-inline-block">
            <Link
              target="_blank"
              underline="always"
              weight="medium"
              onClick={requestCancelationGtm}
              href="https://www.paris.cl/mi-cuenta/mis-compras"
              children={'solicitar una cancelación'}
            />
          </span>
          <span className="co-inline-block">.</span>
        </div>
      </div>
    </div>
  );
};
